"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
var preact_1 = require("preact");
var styles = require("./_toast.scss");
var toast_manager_1 = require("../toast-manager");
var close_icon_1 = require("./close-icon");
var Toast = /** @class */ (function (_super) {
    __extends(Toast, _super);
    function Toast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isShown: true
        };
        _this._onClick = function (e) {
            _this.props.onClick();
            _this._onClose(e);
        };
        _this._onClose = function (e) {
            e.stopPropagation();
            _this.setState({ isShown: false });
            _this.props.onClose(_this.props.id);
        };
        return _this;
    }
    Toast.prototype._getToastSeverityClass = function () {
        switch (this.props.severity) {
            case toast_manager_1.ToastSeverity.Success:
                return styles.successToast;
            case toast_manager_1.ToastSeverity.Warn:
                return styles.warnToast;
            case toast_manager_1.ToastSeverity.Error:
                return styles.errorToast;
            default:
                //info
                return styles.infoToast;
        }
    };
    Toast.prototype.render = function () {
        var _a = this.props, text = _a.text, title = _a.title, icon = _a.icon;
        return ((0, preact_1.h)("div", { className: styles.toastWrapper + ' ' + this._getToastSeverityClass(), onClick: this._onClick },
            (0, preact_1.h)("button", { className: styles.closeButton, onClick: this._onClose },
                (0, preact_1.h)(close_icon_1.CloseIcon, null)),
            (0, preact_1.h)("div", { className: styles.title }, title),
            (0, preact_1.h)("div", { className: styles.toastBody },
                (0, preact_1.h)("div", { className: styles.iconContainer },
                    (0, preact_1.h)("div", { className: styles.iconWrapper }, icon)),
                (0, preact_1.h)("div", { className: styles.text }, text))));
    };
    return Toast;
}(preact_1.Component));
exports.Toast = Toast;
//# sourceMappingURL=toast.js.map